import { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { ErrorResponse, MinimalUser, privateApi } from 'api';

export type GetRefundParams = {
  id: string;
};

export type Refund = {
  tenant_id: string;
  id: string;
  student_user_id: string;
  date: string;
  amount: number;
  memo?: string | null;
  description?: string | null;
  private_notes?: string | null;
  payment_method_id: string | null;
  payment_method: {
    tenant_id: string;
    id: string;
    name: string;
    enabled: boolean;
    allow_method_for_payment: boolean;
    allow_method_for_refund: boolean;
  };
  check_no: string | null;
  voided: boolean;
  reason_voided?: string | null;
  voided_by?: string | null;
  voided_at?: string | null;
  created_by?: string | null;
  des_id?: string | null;
  created_at: string | null;
  updated_by: string | null;
  updated_at: string | null;
  voided_by_user: MinimalUser | null;
  created_by_user: MinimalUser | null;
  updated_by_user: MinimalUser | null;
  student_payment_refunds: {
    tenant_id: string;
    student_payment_id: string;
    student_refund_id: string;
    amount: number;
  }[];
};

export type GetRefundResult = Refund | null;

async function getRefund(params: GetRefundParams): Promise<GetRefundResult | null> {
  if (!params.id) {
    return null;
  }

  // make api call
  const result = await privateApi.get(`${import.meta.env.VITE_API_BASE_URL}/finance/refunds/${params.id}`);

  // return the data object
  return result.data as GetRefundResult;
}

const useGetRefund = createQuery<GetRefundResult, GetRefundParams, AxiosError<ErrorResponse>>({
  queryKey: ['refund'],
  fetcher: (variables) => getRefund(variables),
});

export { useGetRefund };
